module.exports = __webpack_public_path__ + "static/media/insurance.cd900f8d.png";